module.exports = require("/vercel/16327899/config/gatsby-browser.tsx");